import { render, staticRenderFns } from "./TrayectoriaLaboralComponent.vue?vue&type=template&id=18d4b4ca"
import script from "./TrayectoriaLaboralComponent.vue?vue&type=script&lang=js"
export * from "./TrayectoriaLaboralComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports